import { Link } from "react-router-dom";

const articlePreviews = [
  {
    id: 1,
    slug: "cssbuy-sheet-guia-completo",
    title: "CSSBuy Sheet 2026: Guia Completo para Encontrar os Melhores Links e Vendedores",
    excerpt: "Descubra como usar a CSSBuySpreadsheet para encontrar os links mais confiáveis, vendedores verificados e as melhores oportunidades de compra. Guia atualizado com dicas de segurança, QC e frete para brasileiros e portugueses.",
    date: "27 de Junho, 2026",
    readTime: "12 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20of%20a%20notebook%20and%20fashion%20accessories%20on%20a%20warm%20cream%20desk%20surface%20with%20soft%20natural%20morning%20light%20creating%20delicate%20shadows%20minimalist%20aesthetic%20professional%20productivity%20theme%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-01&orientation=landscape",
    featured: true,
  },
  {
    id: 2,
    slug: "cssbuy-vs-pandabuy",
    title: "CSSBuy vs PandaBuy 2026: Qual o Melhor Agente de Compras para Brasileiros?",
    excerpt: "Comparação completa entre CSSBuy e PandaBuy. Analisamos taxas, fretes, tempo de processamento, qualidade de QC e suporte ao cliente. Descubra qual agente oferece o melhor custo-benefício.",
    date: "25 de Junho, 2026",
    readTime: "10 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20elegant%20shipping%20boxes%20side%20by%20side%20on%20a%20warm%20sandstone%20surface%20soft%20natural%20window%20lighting%20creating%20gentle%20shadows%20comparison%20concept%20for%20international%20shopping%20services%20minimal%20clean%20aesthetic%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-02&orientation=landscape",
    featured: false,
  },
  {
    id: 3,
    slug: "seguranca-cssbuy-guia",
    title: "CSSBuy é Seguro? Guia Definitivo de Segurança para Comprar da China em 2026",
    excerpt: "Tudo que você precisa saber sobre segurança no CSSBuy. Como evitar golpes, identificar vendedores confiáveis, entender o processo de QC e proteger seu dinheiro em compras internacionais da China.",
    date: "22 de Junho, 2026",
    readTime: "8 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Miniature%20padlock%20on%20a%20warm%20cream%20colored%20surface%20surrounded%20by%20small%20shopping%20elements%20like%20a%20tiny%20shopping%20cart%20icon%20soft%20natural%20lighting%20conveying%20online%20security%20and%20trust%20minimal%20composition%20no%20text&width=800&height=600&seq=art-prev-03&orientation=landscape",
    featured: false,
  },
  {
    id: 4,
    slug: "melhores-links-nike-cssbuy",
    title: "Melhores Links Nike no CSSBuy 2026: Guia de Tênis e Roupas Esportivas",
    excerpt: "Lista atualizada com os melhores links Nike disponíveis no CSSBuy. Tênis, camisetas, jaquetas e acessórios Nike com vendedores verificados, fotos QC reais e avaliações de qualidade.",
    date: "20 de Junho, 2026",
    readTime: "9 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Single%20premium%20athletic%20sneaker%20in%20cream%20and%20white%20tones%20placed%20on%20a%20warm%20stone%20surface%20with%20soft%20directional%20lighting%20creating%20long%20shadows%20editorial%20sportswear%20photography%20minimal%20style%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-04&orientation=landscape",
    featured: false,
  },
  {
    id: 5,
    slug: "como-usar-cssbuy-iniciantes",
    title: "Como Usar CSSBuy em 2026: Guia Completo para Iniciantes (Passo a Passo)",
    excerpt: "Aprenda a usar o CSSBuy do zero. Tutorial completo com imagens e explicações sobre cadastro, busca de produtos, pedidos, QC, frete e dicas para sua primeira compra da China.",
    date: "18 de Junho, 2026",
    readTime: "11 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20setup%20with%20a%20laptop%20notebook%20and%20small%20product%20samples%20on%20a%20warm%20beige%20surface%20soft%20natural%20daylight%20from%20window%20tutorial%20learning%20concept%20editorial%20photography%20no%20text&width=800&height=600&seq=art-prev-05&orientation=landscape",
    featured: false,
  },
  {
    id: 6,
    slug: "cssbuy-frete-brasil-guia",
    title: "CSSBuy Frete para o Brasil 2026: Cálculo, Taxas e Melhores Rotas de Envio",
    excerpt: "Guia definitivo sobre fretes do CSSBuy para o Brasil. Aprenda a calcular custos, entender taxas de importação, evitar surpresas na alfândega e escolher a melhor rota de envio.",
    date: "15 de Junho, 2026",
    readTime: "7 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Small%20globe%20and%20shipping%20package%20on%20a%20warm%20cream%20colored%20surface%20with%20soft%20natural%20lighting%20representing%20international%20shipping%20and%20delivery%20minimalist%20editorial%20style%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-06&orientation=landscape",
    featured: false,
  },
  {
    id: 7,
    slug: "cssbuy-portugal-compras",
    title: "CSSBuy Portugal 2026: Guia Completo para Comprar da China e Enviar para Portugal",
    excerpt: "Tudo sobre como usar o CSSBuy em Portugal. Informações sobre IVA, taxas alfandegárias, melhores rotas de envio e dicas específicas para compradores portugueses.",
    date: "12 de Junho, 2026",
    readTime: "8 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20shipping%20parcel%20with%20a%20small%20European%20Union%20themed%20accent%20on%20a%20warm%20sandstone%20surface%20soft%20natural%20lighting%20representing%20European%20delivery%20minimal%20editorial%20style%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-07&orientation=landscape",
    featured: false,
  },
  {
    id: 8,
    slug: "marcas-cssbuy-yupoo-2026",
    title: "Marcas no CSSBuy e Yupoo 2026: Como Encontrar os Melhores Vendedores",
    excerpt: "Descubra como usar o Yupoo para encontrar produtos de marca no CSSBuy. Guia com os melhores álbuns Yupoo, vendedores verificados e dicas para identificar produtos de qualidade.",
    date: "10 de Junho, 2026",
    readTime: "10 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20pages%20scattered%20artfully%20on%20a%20warm%20cream%20surface%20with%20a%20magnifying%20glass%20emphasizing%20search%20and%20discovery%20soft%20natural%20lighting%20minimal%20editorial%20style%20no%20text&width=800&height=600&seq=art-prev-08&orientation=landscape",
    featured: false,
  },
  {
    id: 9,
    slug: "qc-cssbuy-guia-definitivo",
    title: "QC no CSSBuy 2026: Guia Definitivo de Controle de Qualidade para Não Ser Enganado",
    excerpt: "Aprenda a interpretar fotos QC do CSSBuy como um profissional. Dicas sobre o que observar em costuras, logos, cores, tamanhos e como solicitar fotos extras antes do envio.",
    date: "08 de Junho, 2026",
    readTime: "9 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20product%20tag%20on%20a%20warm%20beige%20surface%20with%20soft%20diffused%20lighting%20representing%20quality%20control%20inspection%20concept%20minimalist%20editorial%20photography%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-09&orientation=landscape",
    featured: false,
  },
  {
    id: 10,
    slug: "melhores-agentes-china-2026",
    title: "Melhores Agentes de Compra da China 2026: Comparativo Completo com CSSBuy",
    excerpt: "Comparação detalhada entre CSSBuy, Sugargoo, Hagobuy, Superbuy e outros agentes. Descubra qual oferece o melhor custo-benefício, menores taxas e melhor serviço em 2026.",
    date: "05 de Junho, 2026",
    readTime: "11 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Multiple%20small%20international%20shipping%20icons%20and%20symbols%20arranged%20on%20a%20warm%20cream%20surface%20representing%20global%20shopping%20agents%20comparison%20soft%20natural%20lighting%20minimal%20editorial%20style%20no%20text&width=800&height=600&seq=art-prev-10&orientation=landscape",
    featured: false,
  },
  {
    id: 11,
    slug: "cssbuy-tenis-melhores-links",
    title: "CSSBuy Tênis 2026: Os Melhores Links para Comprar Tênis de Qualidade",
    excerpt: "Guia focado em tênis no CSSBuy. Melhores vendedores de tênis, como identificar réplicas de qualidade, comparação de batches e dicas para escolher o tamanho certo.",
    date: "02 de Junho, 2026",
    readTime: "8 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Pair%20of%20elegant%20minimalist%20sneakers%20artfully%20placed%20on%20a%20warm%20stone%20colored%20surface%20with%20soft%20side%20lighting%20creating%20beautiful%20shadows%20premium%20editorial%20product%20photography%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-11&orientation=landscape",
    featured: false,
  },
  {
    id: 12,
    slug: "cssbuy-haul-montagem-guia",
    title: "Como Montar um Haul no CSSBuy 2026: Guia para Economizar no Frete",
    excerpt: "Aprenda a montar hauls eficientes no CSSBuy. Dicas sobre peso ideal, distribuição de produtos, rehearsal shipping e estratégias para reduzir o custo total do frete internacional.",
    date: "30 de Maio, 2026",
    readTime: "7 min de leitura",
    imageUrl: "https://readdy.ai/api/search-image?query=Several%20small%20packages%20neatly%20stacked%20and%20grouped%20on%20a%20warm%20cream%20surface%20representing%20consolidated%20shipping%20and%20haul%20building%20soft%20natural%20lighting%20minimal%20editorial%20style%20no%20text%20no%20logos&width=800&height=600&seq=art-prev-12&orientation=landscape",
    featured: false,
  },
];

export default function ArticlePreviewSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4 whitespace-nowrap">
            Artigos e Guias SEO
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3 max-w-xl">
            Últimos Guias e Artigos CSSBuy
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg">
            Leia nossos guias completos para comprar com mais segurança e
            economizar em cada compra internacional — conteúdo original em português
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articlePreviews.map((article, idx) => (
            <article
              key={article.id}
              className="bg-background-50 rounded-2xl overflow-hidden flex flex-col transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
                {article.featured && (
                  <span className="absolute top-3 left-3 px-3 py-1 text-xs font-semibold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    Destaque
                  </span>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3 leading-snug line-clamp-3">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{article.readTime}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <Link
                  to={`/artigo/${article.slug}`}
                  className={`mt-auto px-6 py-2.5 rounded-full text-sm font-semibold text-center transition-all whitespace-nowrap ${
                    idx === 0
                      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                      : "bg-background-100 text-foreground-700 border border-background-300 hover:bg-background-200 hover:border-background-400"
                  }`}
                >
                  Ler Artigo
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}